import React, { useEffect } from "react"
import { Box, Stack, Typography } from "@mui/material"
import { useTheme } from '@mui/material/styles'

const lightyellow = '#fff9c4'
const lightblue = '#e3f2fd'
const lightgreen = '#e8f5e9'
const lightpink = '#ffebee'

const darkyellow = '#5f4b00'
const darkblue = '#0d47a1'
const darkgreen = '#1b5e20'
const darkpink = '#880e4f'


export default function HeroView(props) {
    const theme = useTheme()

  return (
    <Stack direction='column' spacing={2} paddingTop={3}  >
        <Stack
          sx={{
            // backgroundColor: (theme.palette.mode === 'dark' ? darkyellow : lightyellow),
            padding: {xs: 1, sm: 5},
          }}
          direction={{ sm: 'column', md: 'row' }}
          spacing={2}
          alignItems='center'
          justifyContent='space-between'
        >

          <Box>
            <Typography variant='h5' color='secondary'>group ride calendar</Typography>
            <Typography variant='h4'>Find local organized rides that fit best with your schedule and skills.</Typography>
          </Box>
          <Box
            component="img"
            sx={{
              height: 250,
              width: '100%',
              objectFit: 'contain',
              padding: 0,
            }}
            alt="event picture"
            src='/cal_example2.png'
            borderRadius={3}
          />
        </Stack>
      <Stack
        sx={{
          // backgroundColor: (theme.palette.mode === 'dark' ? darkyellow : lightyellow),
          padding: {xs: 1, sm: 5},
        }}
        direction={{ sm: 'column', md: 'row' }}
        // spacing={1}
        alignItems='center'
        justifyContent='space-between'
      >
        <Box
          component="img"
          sx={{
            height: 300,
            width: '100%',
            objectFit: 'contain',
            padding: 0,
          }}
          alt="ride details picture"
          src='/ride_example2.png'
          borderRadius={3}
        />
        <Box>
          <Typography variant='h5' color="secondary">know before you go</Typography>
          <Typography variant='h4'>No more guessing about the route or pace.</Typography>
        </Box>

      </Stack>
      <Stack
        sx={{
          // backgroundColor: (theme.palette.mode === 'dark' ? darkyellow : lightyellow),
          padding: {xs: 1, sm: 5},
        }}
        direction={{ sm: 'column', md: 'row' }}
        spacing={2}
        alignItems='center'
        justifyContent='space-between'
      >
        <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', width: '100%' }}>
          <Typography variant='h4' sx={{ textAlign: 'center'}}>Coming soon.</Typography>
        </Box>
      </Stack>
    </Stack>
  )
}
